import { render } from "./MovementTransferModal.vue?vue&type=template&id=b9558eb6&scoped=true"
import script from "./MovementTransferModal.vue?vue&type=script&lang=js"
export * from "./MovementTransferModal.vue?vue&type=script&lang=js"

import "./MovementTransferModal.vue?vue&type=style&index=0&id=b9558eb6&scoped=true&lang=css"

import exportComponent from "/builds/aksoftware/software/haushaltsbuchfrontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9558eb6"]])

export default __exports__